
import IconButton from '@/components/common/button/IconButton.vue'
import { commonfunc } from '@/mixin/common'
import InfoContainer from '~/components/common/template/InfoContainer.vue'
import BulkOrderStatus from '~/components/pd/common/address/BulkOrderStatus.vue'
import HolidayOrderStatus from '~/components/pd/common/address/HolidayOrderStatus.vue'
import SCR_MSG_0021 from '@/pages/ms/msg/SCR_MSG_0021.vue'
import DaisoDialog from '~/components/common/modal/DaisoDialog.vue'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  name: 'DeliveryAddress',
  components: {
    IconButton,
    InfoContainer,
    BulkOrderStatus,
    HolidayOrderStatus,
    SCR_MSG_0021,
    DaisoDialog,
    CommonImage
  },
  mixins: [commonfunc],
  props: {
    address: { // 주소
      type: Object,
      default: () => {}
    },
    login: { // 로그인 여부
      type: Boolean,
      default: false
    },
    isUnable: { // 비활성화
      type: Boolean,
      default: false
    },
    pkupDlvUnable: { // 픽업매장 상품 가능 여부
      type: Boolean,
      default: false
    },
    purchaseValue: { // 배송유형 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      type: String,
      default: '01'
    },
    selectMassStore: {
      type: Object,
      default: () => {}
    },
    dlvParmDt: { // 택배배송 도착예정 날짜
      type: String,
      default: ''
    },
    dlvParmWeek: { // 택배배송 도착예정 요일
      type: String,
      default: ''
    },
    dlvParmDtYn: { // 택배배송 배송예정일 노출여부
      type: String,
      default: ''
    },
    hldyDlvFlagYn: { // 휴일배송 가능여부
      type: String,
      default: 'N'
    },
    disStDlvParmDtYn: { // 정기배송 배송예정일 노출여부
      type: String,
      default: ''
    },
    showHolidayInfoBox: {
      type: Boolean,
      default: true
    },
    selectPkupStore: {
      type: Object,
      default: () => {}
    },
    disStHldyDlvFlagYn: { // 정기배송 휴일배송 가능여부
      type: String,
      default: ''
    },
    quickStr: { // 오늘배송
      type: Object,
      default: () => {}
    },
    openDialog: { // 툴팁팝업
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pickup: false, // 매장픽업일 때 텍스트 및 스타일 분기
      mass: false, // 대량주문일 때 텍스트 및 스타일 분기
      fdrm: false, // 정기배송일 때 텍스트 및 스타일 분기
      quick: false, // 오늘배송일 때 텍스트 및 스타일 분기
      textData: { // 택배 배송 텍스트
        loginText: '정확한 배송 정보를 확인해 보세요',
        title: '배송지',
        noAddress: '배송지를 등록해 주세요',
        btnText: '변경',
        btnText2: '등록',
      },
      pickupTextData: { // 픽업 매장 텍스트
        loginText: '픽업 가능 매장을 확인해 보세요',
        title: '픽업매장',
        noAddress: '픽업 매장을 등록해 주세요',
        btnText: '변경',
        btnText2: '등록',
      },
      massTextData: { // 대량 주문 텍스트
        loginText: '대량주문 가능 여부를 확인해 보세요',
        title: '배송지',
        noAddress: '배송지를 등록해 주세요',
        btnText: '변경',
        btnText2: '등록',
      },
      fdrmTextData: { // 정기 배송 텍스트
        loginText: '정기배송 정보를 확인해 보세요',
        title: '배송지',
        noAddress: '배송지를 등록해 주세요',
        btnText: '변경',
        btnText2: '등록',
      },
      quickTextData: { // 오늘 배송 텍스트
        loginText: '오늘배송 가능 여부를 확인해 보세요',
        title: '배송지',
        noAddress: '배송지를 등록해 주세요',
        btnText: '변경',
        btnText2: '등록',
      },
      hdInfoDialogVisible: false
    }
  },
  computed: {
    fullDvyaAddr () {
      let addr = ''
      if (this.address) {
        if (this.pickup) {
          addr = this.address.strNm
        } else {
          let addrFull = ''
          if (this.isNotEmpty(this.address.addrBassEaddr)) {
            addrFull = this.address.addrBassEaddr.split(' ')
          }
          let addrShort = ''
          for (let idx = 1; idx < addrFull.length; idx++) {
            addrShort += addrFull[idx] + ' '
          }
          addr = addrShort
        }
      }
      const nowAddr = addr || (this.pickup ? this.pickupTextData.noAddress : this.textData.noAddress)

      return nowAddr
    },
    pkupKm () {
      let km = ''
      if (!this.isUnable && this.isNotEmpty(this.address) && this.isNotEmpty(this.address.km)) {
        km += ' '
        km += this.address.km >= 1 ? this.address.km.substr(0, this.address.km.length - 2) + 'km' : (this.address.km.substr(2, 1) > 0 ? this.address.km.substr(2, 1) + '00' : this.address.km.substr(2)) + 'm'
      }
      return km
    },
    holidayInfoBoxTy () {
      // return: 0:미노출, 1이상:안내
      if (this.purchaseValue === '01') { // 택배배송
        if (this.dlvParmDtYn !== 'Y' || this.hldyDlvFlagYn !== 'Y') { // 배송예정일, 휴일배송플래그 미노출일 경우
          return 0
        }
        if (this.login) { // 로그인시
          if (!this.address) { // 배송지 미등록시
            return 1
          } else if (this.address) { // 휴일배송 배송가능한 배송지로 등록되어 있을시
            return 2
          }
        }
        if (!this.login) { // 비로그인시, 배송예정일이 휴일배송일 경우 1번타입 노출 / 휴일배송 아니면 미노출
          return this.hldyDlvFlagYn === 'Y' ? 1 : 0
        }
      } else if (this.purchaseValue === '03') { // 정기배송
        if (this.disStDlvParmDtYn !== 'Y' || this.disStHldyDlvFlagYn !== 'Y') { // 배송예정일, 휴일배송플래그 미노출일 경우
          return 0
        }
        if (this.login) { // 로그인시
          if (!this.address) { // 배송지 미등록시
            return 1
          } else if (this.address) { // 휴일배송 배송가능한 배송지로 등록되어 있을시
            return 2
          }
        }
        if (!this.login) { // 비로그인시, 배송예정일이 휴일배송일 경우 1번타입 노출 / 휴일배송 아니면 미노출
          return this.disStHldyDlvFlagYn === 'Y' ? 1 : 0
        }
      }
      return 0
    }
  },
  watch: {
    purchaseValue (item) {
      if (item === '01') { // 택배배송
        this.pickup = false
        this.mass = false
        this.fdrm = false
        this.quick = false
      } else if (item === '02') { // 픽업주문
        this.pickup = true
        this.mass = false
        this.fdrm = false
        this.quick = false
      } else if (item === '04') { // 대량주문
        this.pickup = false
        this.mass = true
        this.fdrm = false
        this.quick = false
      } else if (item === '05') { // 오늘배송
        this.pickup = false
        this.mass = false
        this.fdrm = false
        this.quick = true
      } else { // 정기배송
        this.pickup = false
        this.mass = false
        this.fdrm = true
        this.quick = false
      }
    },
    openDialog (val) {
      if (val === true) {
        this.hdInfoDialogVisible = true
      }
    },
    hdInfoDialogVisible (val) {
      if (val === false) {
        this.$emit('closeDialog')
      }
    }
  },
  mounted () {
  },
  methods: {
    moveLogin () {
      this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
    },
    openStoreInfo () {
      this.$refs.SCR_MSG_0021.strCd = this.purchaseValue === '04' ? this.selectMassStore.strCd : this.selectPkupStore.strCd
      if (this.$refs.SCR_MSG_0021.strCd) {
        this.$refs.SCR_MSG_0021.outerVisible = true
      }
    },
    openLayer () {
      this.address ? this.$emit('openLayer') : this.$emit('openEditLayer')
    }
  }
}
